import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { HYDRATE } from 'next-redux-wrapper';
import { TopFilter } from '@app/enums/shop';

const initialState = {
  shopList: [],
  saveList: [],
  partnerShops: [],
  ListDistance: [],
  filters: [],
  activeFilters: [],
  visibleFilters: [],
  activeShop: null,
  showFilter: false,

  topFilter: TopFilter,
  comments: {
    comentsList: [],
    url: '/pages/view/obratnaya-svyaz/',
  },
  loading: false,
  loadingDistance: false,
  updateTopFilters: true,
  banner: {
    active: false,
    text: 'Все центры открыты для обслуживания',
    button: {
      color: '#fff',
      background: '#E22F22',
      url: '#',
      text: 'Узнать больше',
    },
  },
  widget: [],
};

export const shopsSlice = createSlice({
  name: 'shops',
  initialState,
  reducers: {
    setShopsData: (state, action: PayloadAction<any>) => {
      const { shops, visibleFilters, dataWidget } = action.payload.shopsData;
      state.shopList = shops;
      state.saveList = shops;
      state.filters = action.payload.filter;
      state.visibleFilters = visibleFilters;
      state.comments = action.payload.comments;
      state.banner = action.payload.infoMessage;
      state.widget = dataWidget;
    },
    setListShop: (state, action: PayloadAction<any>) => {
      const { shops, visibleFilters } = action.payload;
      state.shopList = shops;
      state.saveList = shops;
      state.visibleFilters = visibleFilters;
      state.loading = false;
      state.activeShop = null;
      state.loadingDistance = true;
    },
    updateListShop: (state, action: PayloadAction<any>) => {
      state.shopList = action.payload;
      state.updateTopFilters = false;
      state.activeShop = null;
    },
    setActiveShop: (state, action: PayloadAction<any>) => {
      state.activeShop = action.payload;
    },
    setShowFilter: (state, action: PayloadAction<any>) => {
      state.showFilter = action.payload;
    },
    closeBanner: (state, action: PayloadAction<any>) => {
      state.banner.active = action.payload;
    },
    setLoading: (state, action: PayloadAction<any>) => {
      state.loading = action.payload;
    },
    // фильтрация магазинов по сервисам
    upadeFilter: (state, action: PayloadAction<any>) => {
      const newArray = state?.filters[action.payload.type]?.map(item => {
        if (item?.id && item?.id === action.payload?.id) {
          item.checked = !item.checked;
        }
        return item;
      });
      state.filters[action.payload.type] = newArray;
      const listId = [];
      for (const key in state.filters) {
        state.filters[key].forEach(item => {
          if (item.checked) {
            listId.push(item.id);
          }
        });
      }
      state.activeFilters = listId;
      state.loading = true;
    },
    // сброс фильтров
    resetFilter: state => {
      for (const key in state.filters) {
        state.filters[key].map(item => {
          if (item.checked) {
            item.checked = !item.checked;
          }
          return item;
        });
      }
      state.activeFilters = [];
      state.loading = true;
    },
    // фильтрация магазинов по параметрам
    updateTopFilter: (state, action: PayloadAction<any>) => {
      const newArray = state.topFilter.map(item => {
        if (item.id === action.payload.id) {
          item.checked = !item.checked;
        }
        return item;
      });
      state.topFilter = newArray;
      state.updateTopFilters = true;
    },
    setTopFilterVisible: state => {
      const newArray = [...state.topFilter];
      newArray[0].checked = false;
      newArray[1].checked = false;
      newArray[2].checked = false;
      newArray[0].visible = !!state.shopList?.find(x => x.record);
      newArray[1].visible = !!state.shopList?.find(x => x.distance);
      newArray[2].visible = !!state.shopList?.find(x => x.corporate);
      state.topFilter = newArray;
      state.updateTopFilters = false;
    },
    addDistance: (state, action: PayloadAction<any>) => {
      state.loadingDistance = false;
      state.saveList = action.payload;
      state.shopList = action.payload;
      state.updateTopFilters = true;
    },
    setPartnerShops: (state, action: PayloadAction<any>) => {
      state.partnerShops = action.payload;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.shops,
      };
    },
  },
});

export const {
  setShopsData,
  updateTopFilter,
  setListShop,
  setActiveShop,
  setShowFilter,
  closeBanner,
  setLoading,
  upadeFilter,
  resetFilter,
  setTopFilterVisible,
  addDistance,
  updateListShop,
  setPartnerShops,
} = shopsSlice.actions;

export const selectShopsData = (state: RootState) => state.shops;
export const selectBanner = (state: RootState) => state.shops.banner;
export const selectReviewData = (state: RootState) => state.shops.comments;
export const selectActiveShop = (state: RootState) => state.shops.activeShop;
export const selectShowFilter = (state: RootState) => state.shops.showFilter;
export const selectPartnerShops = (state: RootState) => state.shops.partnerShops;

export const shopsReducer = shopsSlice.reducer;
